module.exports = __webpack_public_path__ + "static/media/product_gmc.1c471058.svg";